module.exports = __webpack_public_path__ + "static/media/knowledge_village_logo.66838ec0.svg";